import React, { useEffect, useState, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet";
import "./store-page.css";
import ReCAPTCHA from "react-google-recaptcha";
import { firebase, firebaseFirestore, getCollection, getCoupons, placeOrder } from "./firebase";

const StorePage = (props) => {
  const [stores, setStores] = useState([{ name: "Loading...", status: false }]);
  const [coupons, setCoupons] = useState([]);
  const [selectedCoupon, setSelectedCoupon] = useState("");
  const [selectedStore, setSelectedStore] = useState(null);
  const [selectedStoreIndex, setSelectedStoreIndex] = useState(null);
  const [order, setOrder] = useState("");
  const [address, setAddress] = useState("");
  const [captcha, setCaptcha] = useState(false);
  const [slideStoreName, setSlideStoreName] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [captchaReady, setCaptchaReady] = useState(false);
  const [user, setUser] = useState(null);
  const [applyCouponPopUp, setApplyCouponPopUp] = useState(false);
  let history = useHistory();

  useEffect(async () => {
    try {
      if (!('firebase:authUser:AIzaSyCCxX4y8SwTmRNIJca6ms0v-T7O_FCQm0w:[DEFAULT]' in localStorage)) {
        history.push('/account');
      }
      // let user = firebase.decryptFunction(localStorage.getItem('0_k6n.l9fffp0gqw'));
      let user1 = localStorage.getItem('firebase:authUser:AIzaSyCCxX4y8SwTmRNIJca6ms0v-T7O_FCQm0w:[DEFAULT]');
      user1 = JSON.parse(user1);
      setUser(user1);
      if ((Date.now() - parseInt(user1.lastLoginAt)) / (24 * 60 * 60 * 1000) > 30) {
        history.push('/account');
      }
      if (user1.emailVerified === false) {
        history.push('/account');
      }
      let query = firebaseFirestore.query(firebaseFirestore.collection(firebase.db, "orders"),
        firebaseFirestore.and(
          firebaseFirestore.where('email', '==', user1.email),
          firebaseFirestore.or(
            firebaseFirestore.where('status', '==', 'pending'),
            firebaseFirestore.where('status', '==', 'accepted')
          )
        )
      );
      let docs = await firebaseFirestore.getDocs(query);
      if (docs.size > 0) {
        switch (docs.docs[0].data().status) {
          case 'pending':
            history.push('/pending', { orderId: docs.docs[0].id });
            break;
          case 'accepted':
            history.push('/chat', { orderId: docs.docs[0].id });
            break;
          default:
            break;
        }
      }
      // console.log(user);
    } catch (err) {
      console.log(err)
    }
  }, []);

  useEffect(()=>{
      
  },[])

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://www.google.com/recaptcha/api.js";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
    script.addEventListener("load", () => {
      setCaptchaReady(true);
    });
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    window.addEventListener("resize", () => {
      setWindowWidth(window.innerWidth);
    });
  }, []);

  useEffect(async () => {
    await getCollection("stores").then((res) => {
      setStores(res[0].stores);
    });
  }, []);

  const memoizedCoupons = useMemo(async () => {
    if (applyCouponPopUp) {
      const res = await getCoupons(user?.email);
      if (res.length === 0) {
        return [];
      } else {
        return res;
      }
    }
    return [];
  }, [applyCouponPopUp]);

  useEffect(() => {
    memoizedCoupons.then(res => {
      setCoupons(res);
    })
  }, [memoizedCoupons]);

  useEffect(() => {
    if (selectedStore) {
      setSlideStoreName(true);
    }
  }, [selectedStore]);

  const handleOrder = async () => {
    if (
      !order ||
      !selectedStore ||
      !captcha ||
      stores.filter((e) => e.name === selectedStore)[0].status === false
    ) {
      return;
    }
    const orderObj = {
      shop: selectedStore,
      description: order,
      status: "pending",
      timestamp: firebaseFirestore.Timestamp.now(),
      email: user?.email,
      address,
      isReferral: false,
      name: user?.displayName,
      isWebsite: true,
    };
    let res = await placeOrder(orderObj);
    if (res.id) {
      setOrder("");
      setSelectedStore(null);
      setCaptcha(false);
      setAddress("");
      setSelectedCoupon("");
      setSlideStoreName(false);
      history.push('/pending', { orderId: res.id })
    } else {
      alert(res);
    }
  };

  return (
    <div className="store-page-container">
      <Helmet>
        <title>storePage - DeliBuddy</title>
        <meta property="og:title" content="storePage - DeliBuddy" />
      </Helmet>
      <div className="store-page-container1">
        <svg viewBox="0 0 1024 1024" className="store-page-icon1" onClick={()=>{
          history.push('/profile')
        }}>
          <path d="M512 0c282.857 0 512 229.143 512 512 0 281.143-228 512-512 512-283.429 0-512-230.286-512-512 0-282.857 229.143-512 512-512zM865.714 772c53.143-73.143 85.143-162.857 85.143-260 0-241.714-197.143-438.857-438.857-438.857s-438.857 197.143-438.857 438.857c0 97.143 32 186.857 85.143 260 20.571-102.286 70.286-186.857 174.857-186.857 46.286 45.143 109.143 73.143 178.857 73.143s132.571-28 178.857-73.143c104.571 0 154.286 84.571 174.857 186.857zM731.429 402.286c0-121.143-98.286-219.429-219.429-219.429s-219.429 98.286-219.429 219.429 98.286 219.429 219.429 219.429 219.429-98.286 219.429-219.429z"></path>
        </svg>
        <div className="store-page-stores">
          <div className="store-page-container2">
            <span className="store-page-text">Choose what you need.</span>
            {/* <span>{JSON.stringify(user)}</span> */}
          </div>
          <div className="store-page-container3">
            {stores.map((e, index) => (
              <button
                className={`store-page-button button ${selectedStoreIndex === index ? "store_selected" : ""
                  }`}
                onClick={async () => {
                  setOrder("");
                  setSelectedStoreIndex(index);
                  setSelectedStore(e?.name);
                  if (windowWidth < 768) {
                    await new Promise((r) => setTimeout(r, 200));
                    document
                      .querySelector(".store-page-order-details")
                      .scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                        inline: "center",
                      });
                  }
                }}
                disabled={!e?.status}
                key={e?.name}
              >
                <span className="store-page-text1">
                  <span>{e?.name}</span>
                  <br></br>
                </span>
                <span
                  className="store-page-text4"
                  style={{ color: e?.status ? "#fff" : "#e1573a" }}
                >
                  {e?.status ? "OPEN" : "CLOSED"}
                </span>
              </button>
            ))}
          </div>
        </div>
        <div className="store-page-order-details">
          {selectedStore && (
            <>
              <div className="store-page-container4">
                <svg
                  viewBox="0 0 1024 1024"
                  className="store-page-icon"
                  onClick={() => {
                    document
                      .querySelector(".store-page-stores")
                      .scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                        inline: "center",
                      });
                    setOrder("");
                    setSelectedStore(null);
                    setSelectedStoreIndex(null);
                  }}
                >
                  <path d="M498 166l-346 346 346 346-76 76-422-422 422-422z"></path>
                </svg>
                <span
                  className={`store-page-text5 ${slideStoreName ? "slide-in-left" : ""
                    }`}
                  onAnimationEnd={() => {
                    setSlideStoreName(false);
                  }}
                >
                  {selectedStore || "Name of the shop"}
                </span>
              </div>
              <div className="store-page-container5">
                <textarea
                  placeholder="Please type your order"
                  className="store-page-textarea textarea slide-in-left"
                  onChange={(e) => {
                    setOrder(String(e.target.value));
                  }}
                  value={order}
                  maxLength={500}
                  minLength={5}
                />
                <textarea
                  placeholder="Please type the address for delivery (location, hostel)"
                  className="store-page-textarea textarea slide-in-left"
                  onChange={(e) => {
                    setAddress(String(e.target.value));
                  }}
                  value={address}
                  maxLength={500}
                  minLength={5}
                />
                {/* <span className="store-page-coupon-text slide-in-left"
                onClick={() => {
                  setApplyCouponPopUp(true);
                  document.addEventListener('mousedown', (e) => {
                    console.log(e.target.closest('.store-page-container06'))
                    if (!e.target.closest('.store-page-container06')) {
                      setApplyCouponPopUp(false)
                    }
                  })
                }}
                >
                  Apply Coupon
                </span> */}
                {captchaReady ? (
                  <ReCAPTCHA
                    sitekey="6LfSxXMlAAAAAOu6gW34RJrYPVe4ZHxKh3Su_-Vn"
                    onChange={(e) => {
                      if (e) {
                        setCaptcha(true);
                      } else {
                        setCaptcha(false);
                      }
                    }}
                    className="slide-in-left"
                    style={{
                      marginTop: "1%",
                    }}
                  />
                ) : (
                  <span
                    style={{
                      fontWeight: "600",
                      fontSize: "15px",
                      color: "#000",
                    }}
                  >
                    Loading ReCAPTCHA...
                  </span>
                )}
                <button
                  className="store-page-button1 button slide-in-left"
                  disabled={!(order.length > 4) || !captcha || !(address.length > 4) || (stores.filter((e) => e.name === selectedStore)[0]?.status === false)}
                  onClick={() => {
                    if (
                      !order ||
                      !selectedStore ||
                      !captcha ||
                      stores.filter((e) => e.name === selectedStore)[0]
                        .status === false
                    ) {
                      document.querySelector(
                        ".store-page-button1"
                      ).disabled = true;
                      return;
                    }
                    handleOrder();
                  }}
                >
                  PLACE ORDER
                </button>
              </div>
            </>
          )}
        </div>
      </div>
      {applyCouponPopUp && (<div className="store-page-container06">
        <div className="store-page-container07">
          <div className="store-page-container08">
            <div className="store-page-container09">
              <span className="store-page-text06">
                <span>Coupons</span>
                <br></br>
              </span>
              <svg viewBox="0 0 1024 1024" className="store-page-icon2" onClick={() => {
                setApplyCouponPopUp(false);
              }}>
                <path d="M1014.662 822.66c-0.004-0.004-0.008-0.008-0.012-0.010l-310.644-310.65 310.644-310.65c0.004-0.004 0.008-0.006 0.012-0.010 3.344-3.346 5.762-7.254 7.312-11.416 4.246-11.376 1.824-24.682-7.324-33.83l-146.746-146.746c-9.148-9.146-22.45-11.566-33.828-7.32-4.16 1.55-8.070 3.968-11.418 7.31 0 0.004-0.004 0.006-0.008 0.010l-310.648 310.652-310.648-310.65c-0.004-0.004-0.006-0.006-0.010-0.010-3.346-3.342-7.254-5.76-11.414-7.31-11.38-4.248-24.682-1.826-33.83 7.32l-146.748 146.748c-9.148 9.148-11.568 22.452-7.322 33.828 1.552 4.16 3.97 8.072 7.312 11.416 0.004 0.002 0.006 0.006 0.010 0.010l310.65 310.648-310.65 310.652c-0.002 0.004-0.006 0.006-0.008 0.010-3.342 3.346-5.76 7.254-7.314 11.414-4.248 11.376-1.826 24.682 7.322 33.83l146.748 146.746c9.15 9.148 22.452 11.568 33.83 7.322 4.16-1.552 8.070-3.97 11.416-7.312 0.002-0.004 0.006-0.006 0.010-0.010l310.648-310.65 310.648 310.65c0.004 0.002 0.008 0.006 0.012 0.008 3.348 3.344 7.254 5.762 11.414 7.314 11.378 4.246 24.684 1.826 33.828-7.322l146.746-146.748c9.148-9.148 11.57-22.454 7.324-33.83-1.552-4.16-3.97-8.068-7.314-11.414z"></path>
              </svg>
            </div>
            <div className="store-page-container10">
              {coupons.map((e, index) => (
                <div className="store-page-container11">
                  <span className="store-page-text09">FREEDELIVERY</span>
                  <span className="store-page-text10">
                    Get 1 order delivered free to your location
                  </span>
                  <button className="store-page-button2 button" onClick={() => {
                    setApplyCouponPopUp(false);
                    setSelectedCoupon(e);
                  }}>Apply</button>
                </div>
              ))
              }
            </div>
          </div>
        </div>
      </div>)}
    </div>
  );
};

export default StorePage;
